import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { UIContext } from '../../../Context/UIContext'

const children = {
    hidden: { opacity: 0, y: '100%' },
    show: { opacity: 1, y: 0, transition: { duration: 0.75, type: 'tween' } }
}

const Award = React.forwardRef(({data}, ref) => {
    const { setSelectedModal, setModalVisible } = useContext(UIContext)

    const handleOpenModal = () => {
        const modalData = {
            title: data.title,
            image: data.image,
            url: data.url,
            info: data.info
        }
        setSelectedModal(modalData)
        setModalVisible(true)
    }
    return (
        <motion.div
            ref={ref}
            className="mga-awards-section__grid__item"
            whileHover={{
                scale: 1.05,
                transition: { duration: 0.5 }
            }}
            variants={children}
        >
            <button
                onClick={handleOpenModal}
            >
                <img src={data.image} alt={data.title} />
            </button>
        </motion.div>
    )
})
const MotionAward = motion(Award)

export default MotionAward